<form
  #recipientAnotherFormElement
  [formGroup]="recipientAnotherForm"
  (ngSubmit)="nativeSubmit()"
>
  <div class="field mb-4">
    <!-- Start::title -->
    <span class="text-900 text-2xl block font-semibold mb-5"
      >Tú o la siguiente persona podrán
      {{ checkoutService.shippingLabel() }} el pedido</span
    >
    <!-- End::title -->

    <!-- Start::input nombre -->
    <div class="field mb-4 flex flex-column">
      <label for="name" class="font-semibold text-900">Nombres</label>
      <app-name-input id="name" formControlName="name" />
      <small id="name-help"> Ej: Nicolás </small>
    </div>
    <!-- End::input nombre -->

    <!-- Start::input apellido -->
    <div class="field mb-4 flex flex-column">
      <label for="lastName" class="font-semibold text-900">Apellidos</label>
      <app-name-input id="lastName" formControlName="lastName" />
      <small id="lastName-help"> Ej: Rojas </small>
    </div>
    <!-- End::input apellido -->

    <!-- Start::input documento -->
    <div class="field mb-4 flex flex-column">
      <label for="documentId" class="font-semibold text-900">{{
        documentIdLabel
      }}</label>
      <app-document-id-input id="documentId" formControlName="documentId" />
      <small id="documentId-help"> Ej: {{ documentIdSample }} </small>
    </div>
    <!-- End::input documento -->

    <!-- Start::input teléfono -->
    <div class="field mb-4 flex flex-column">
      <label for="phone" class="font-semibold text-900">Teléfono</label>
      <app-phone-input id="phone" formControlName="phone" />
      <small id="phone-help"> Ej: 9 1234 9876 </small>
    </div>
    <!-- End::input teléfono -->
  </div>
</form>
